import { CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";


export const SignIn = ({ status, darkMode }) => {
  return (
    <Dialog 
      open={true} 
      onClose={() => {}}
      fullWidth={true}
      maxWidth="sm"
      style={{overflow: 'hidden'}}
      PaperProps={{
        style: {
          backgroundColor: darkMode ? 'black' : 'white'
        }
      }}
    >
      <DialogContent style={{minHeight: 400, overflow: 'hidden', backgroundColor: darkMode ? 'black' : 'white'}}>
        <img src={process.env.PUBLIC_URL + '/img/ssd_logomark_primary.png'} alt="subsurface dynamics" style={{width: 100}}></img>
        
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: 400, overflow: 'hidden'}}>
          {status === "error" ?
            <Typography color={darkMode ? 'white' : 'black'}>Could not sign in. Please try again.</Typography>
            :
            <>
              <Typography style={{marginBottom: 20}} color={darkMode ? 'white' : 'black'}>Signing in...</Typography>
              <CircularProgress></CircularProgress>
            </>
          }
          <Typography style={{position: 'absolute', textAlign: 'center', bottom: 20, fontSize: 14}}>© 2024 Subsurface Dynamics Inc. All rights reserved.</Typography>
        </div>

      </DialogContent>
    </Dialog>
  );
};